export default __webpack_public_path__ + "static/Mobile-Access-0e76b3b233558b4707fe43214dce80c3.webp";